module.exports = __webpack_public_path__ + "img/25-s.7deafc17.png";